/**
 * R1 (SPEC-v017-completion-2026-09-27, AC1): her literal report was
 * quantity 10, unit price 250, and the invoice not tallying to 2500 -- qty
 * x rate must fill the amount that actually gets billed. Returns null (never
 * NaN) when either side is not yet a valid number, so callers can leave the
 * amount alone until both are entered.
 *
 * Shared by the Add Item form and the existing-line editor (InvoiceItemRow),
 * so both bill the same cents for the same quantity and rate.
 */
export function deriveAmountFromQtyRate(quantity: string, unitPrice: string): number | null {
  const q = parseFloat(quantity);
  const p = parseFloat(unitPrice);
  if (!Number.isFinite(q) || !Number.isFinite(p)) return null;
  // Money is cents, so round to cents HALF_UP exactly once, here, and let both
  // panels use the result. Returning the raw product (the original shape) made
  // the two panels disagree about what to bill: the Create New panel applied
  // .toFixed(2) and sent 1.84 for 1.5 x 1.23 (an underbill), while the
  // existing-item panel sent 1.845 unrounded -- and 96.93249999999999 for
  // 7.25 x 13.37, a raw binary float submitted as an amount.
  // EPSILON nudges the ties that binary floating point represents a hair low
  // (1.005 * 100 is 100.49999999999999) up to the half they are meant to be.
  const cents = Math.round((q * p + Number.EPSILON) * 100);
  return cents / 100;
}
